import { apiClient } from "./apiClient";

// Credit services
export const creditService = {
  // Get balance
  getBalance: async () => {
    try {
      const response = await apiClient.get("/credit/balance");
      return response.data;
    } catch (error) {
      console.error("Error getting balance:", error);
      return { amount: "⁉️", error: "Error getting balance" };
    }
  },

  getBalanceByUserId: async (userId) => {
    try {
      const response = await apiClient.get("/admin/credits/get-balance-by-user-id", {
        params: {
          id: userId,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error getting balance by user id:", error);
      return { amount: "⁉️", error: "Error getting balance by user id" };
    }
  },

  checkSufficientCredits: async (taskType) => {
    try {
      const response = await apiClient.get(`/credit/check-sufficient-credits?taskType=${taskType}`);
      return response.data;
    } catch (error) {
      console.error("Error checking sufficient credits:", error);
      return { sufficient: false, error: "Error checking sufficient credits" };
    }
  },

  addOrSubtractCreditsAdmin: async (amount, userId) => {
    try {
      const response = await apiClient.post("/admin/credits/add-or-subtract", { amount, userId });
      return response.data;
    } catch (error) {
      console.error("Error adding or subtracting credits:", error);
      return { error: "Error adding or subtracting credits" };
    }
  },
};
